import { NavigationItem } from "app/layout/main/components/navigation/types";

import { FinanceRoutes } from "./routes";

export const useFinanceNavigation = (): NavigationItem[] => {
  return [
    {
      iconName: "tdesign:chart-analytics",
      path: FinanceRoutes.DASHBOARD,
      title: "Dashboard",
    },
    {
      iconName: "fluent:money-hand-16-regular",
      path: FinanceRoutes.VARIABLE_EXPENSES,
      title: "Výdaje",
    },
  ];
};
